import OnlyIfAuthenticated from "../../state/currentUser/guards/OnlyIfAuthenticated";
import AdminApp from "./Admin/AdminApp";
import {
  ApiException,
  AuthClient,
  CategoryClient,
  TokenDto,
  UsersClient,
} from "../../utilities/backend/client";
import { useEffect, useState } from "react";
import { Box, CircularProgress, Stack, styled } from "@mui/material";
import HomeLoggedIn from "./User/loggedIn/HomeLoggedIn";
import { setRole, setToken, removeToken } from "../../utilities/redux/actions";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { RootState } from "../../utilities/redux/store";

const StackRes1 = styled(Stack)(({ theme }) => ({
  justifyContent: "center",
  alignItems: "center",
  width: "1280px",
  [theme.breakpoints.down("sm")]: {
    width: "100%",
  },
}));

const StackRes2 = styled(Stack)(({ theme }) => ({
  spacing: "6",
  alignItems: "center",
  justifyContent: "center",
  paddingBottom: "160px",
  flexDirection: "row",
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
  },
}));

const StackRes3 = styled(Stack)(({ theme }) => ({
  justifyContent: "center",
  alignItems: "center",
  paddingTop: "41px",
  marginTop: "0 !important",
  paddingBottom: "160px",
  flexDirection: "row",
  gap: "100px",
  [theme.breakpoints.down("sm")]: {
    display: "flex",
    flexDirection: "column",
    gap: "100px",
  },
}));

const Home2 = () => {
  const categoryClient = new CategoryClient();
  const authClient = new AuthClient();
  const [apiError, setApiError] = useState<ApiException | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  const userClient = new UsersClient();
  const userEmail = localStorage.getItem("email");
  const userPassword = localStorage.getItem("password");

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const token: TokenDto = {
    token: useSelector((state: RootState) => state.token.token) || "",
  };

  const [selectedCategoriesIndex, setSelectedCategoriesIndex] = useState("");
  const [categoryList, setCategoryList] = useState<any[]>([]);

  useEffect(() => {
    categoryClient
      .category_GetAll()
      .then(async (response) => {
        const categories = JSON.parse(await response.data.text());
        categories.map((i: any) => (i.selected = true));
        const selectedI = categories
          .filter((i: any) => i.selected)
          .map((i: any) => i.id);
        console.log(selectedI);
        setSelectedCategoriesIndex(selectedI.join(","));
        setCategoryList(categories);
      })
      .catch((error) => {
        console.log(error);
      });

    userClient
      .users_UpdateActiveStatus(userEmail!, true)
      .then(() => {
        login();
        setLoading(false);
      })
      .catch((error) => {
        setApiError(error);
      });
  }, []);

  const login = () => {
    authClient
      .auth_Authenticate({ email: userEmail!, password: userPassword! })
      .then(async (response) => {
        const token = await response?.data.text();
        if (token !== undefined) {
          dispatch(setRole(JSON.parse(atob(token.split(".")[1])).role));
          dispatch(setToken(JSON.parse(token).token));
        } else {
          dispatch(removeToken());
        }
        navigate("/home2");
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const isAdmin =
    token && token.token
      ? JSON.parse(atob(token.token.split(".")[1])).role === "Admin"
      : false;

  useEffect(() => {
    const selectedI = categoryList.filter((i) => i.selected).map((i) => i.id);
    setSelectedCategoriesIndex(selectedI.join(","));
  }, [categoryList]);

  return (
    <>
      {loading ? (
        <Stack justifyContent={"center"} alignItems={"center"} mt={"100px"}>
          <Box sx={{ margin: "0 auto" }}>
            <CircularProgress />
          </Box>
        </Stack>
      ) : (
        <OnlyIfAuthenticated
          children={isAdmin ? <AdminApp /> : <HomeLoggedIn />}
        />
      )}
    </>
  );
};

export default Home2;
